import React, { useState, useEffect } from "react";

export default function VideoPlayer({
  thumbnail,
  videos
}) {

  const sourceElements = Array.isArray(videos) && videos.map((video, index) => (
    <source key={`video-${index}`} src={video.file} type={video.mimeType} />
  ));

  return (
    <video id="video" className="gc__video_message" controls preload="metadata" poster={thumbnail}>
      {sourceElements}
      <object type="application/x-shockwave-flash" data={`flash-player.swf?videoUrl=${videos[0].file}`} width="1024" height="576">
        <param name="movie" value={`flash-player.swf?videoUrl=${videos[0].file}`} />
        <param name="allowfullscreen" value="true" />
        <param name="wmode" value="transparent" />
        <param name="flashvars" value={`controlbar=over&amp;image=img/poster.jpg&amp;file=flash-player.swf?videoUrl=${videos[0].file}`} />
        <img alt="No video playback possible" src="" width="1024" height="428" title="No video playback possible, please download the video from the link below" />
        <a href={videos[0].file} download >Download Video</a>
      </object>
    </video>
  );

};
